const dataset_specific_data = {
    //TODO: This can be obtained from the json-file
    "20newsgroups": {
        "labels": ["label", "random_int"],
        "default_label": "label"
    },
    "valurank": {
        "labels": ["label"],
        "default_label": "label"
    },
    "wikipedia": {
        "labels": ["label", "predicted_topic"],
        "default_label": "label"
    },
    "partition_vectors": {
        "labels": ['category_code', 'is_primary', 'label', 'doc_id', 'embed_category', 'embed_source'],
        "default_label": "category_code"
    }
}

export default dataset_specific_data;


